import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import getOrgById from '../../hooks/getOrgById';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SideBar4 from '../../components/Sidebar/SideBar4';
import {Upload, message, Switch, Select, Form, Input } from 'antd';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import useFetchOrganizationTypes from '../../hooks/fetchOrganizationTypes';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import useFetchCities from '../../hooks/fetchCities';
import useFetchCountries from '../../hooks/fetchCountries';
import InputMask from 'react-input-mask';
import useFetchStates from '../../hooks/fetchStates';
import { app } from '../../config';
import { PlusOutlined,LeftCircleOutlined,LoadingOutlined  } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
const { TextArea } = Input;
const EditOrg = () => {
  const [phone, setPhone] = useState();
  const [contactPersonPhone, setContactPersonPhone] = useState();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [imageUrl1, setImageUrl1] = useState();
  const [uploadedImg, setUploadedImg] = useState('');
  const [uploadedImg1, setUploadedImg1] = useState('');
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addOrgRes, setAddOrgRes] = useState({});
  const [causeAmountPercentage,setcauseAmountPercentage]=useState();
  const [managementFeePercentage,setmanagementFeePercentage]=useState();
  const [show, setShow] = useState(false); 
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
const handleuploadChange = (info) => {
  if (info.file.status === 'uploading') {
    setLoading(true);
    return;
  }
  if (info.file.status === 'done') {
    // Get this url from response in real world.
    info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
    info.file?setUploadedImg(info.file.response.data.Location):" "
    getBase64(info.file.originFileObj, (url) => {
      setLoading(false);
      setImageUrl(url);
    });
  }
};
const handleuploadChange2 = (info) => {
  if (info.file.status === 'uploading') {
    setLoading1(true);
    return;
  }
  if (info.file.status === 'done') {
    // Get this url from response in real world.
    info.file?console.log(info.file.response.data.Location):console.log("Not found"); 
    info.file?setUploadedImg1(info.file.response.data.Location):" "
    getBase64(info.file.originFileObj, (url) => {
      setLoading1(false);
      setImageUrl1(url);
    });
  }
};
const beforeUpload = (file) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  const token=getTokenfromUserObj();
  const headers={auth:token}
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem('user'));
  let orgObj = {};
  let objId = JSON.parse(localStorage.getItem('orgId'));
  if(user.userType==="O") objId = user.organizationId;
  console.log(objId);
  let res = getOrgById(objId);
  console.log(res.response);
  if (res.response) orgObj = res.response.data;
  console.log(orgObj);
  if (res.response) orgObj = res.response.data;
  let orgTypeRes = useFetchOrganizationTypes();
  let orgTypes = orgTypeRes.response ? orgTypeRes.response.data : [];
  console.log(orgTypes);
  const countriesResp = useFetchCountries();
  const countries = countriesResp.response ? countriesResp.response.data : [];
  // console.log(countries);
  const statesResp = useFetchStates();
  // console.log(statesResp);
  const states = statesResp.response ? statesResp.response.data : [];
  const handleChange = (event) => {
    setPhone(event.target.value);
    // handle phone number input here
  };
  const handleContactPersonChange = (event) => {
    setContactPersonPhone(event.target.value);
    // handle phone number input here
  };

  function goBack() {
    if(user.userType==="O") navigate('/orguser/view',{replace:true});
    else navigate('/organizations/listall',{replace:true});
   }
   window.addEventListener('popstate', goBack);
  const uploadData = async (uploadObj) => {
    console.log('Function Running');
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/org/update/${orgObj.organizationId}`, uploadObj,{headers:{auth:token}});
      console.log('🚀 ~ file: EditOrg.js:49 ~ uploadData ~ res', res);
      if (res.data.statusCode === 200){setAddOrgRes(res.data);
      user.userType==='A'?setTimeout(()=>{navigate('/organizations/listall')},1000):setTimeout(()=>{navigate('/organization/dashboard')},1000)
      }
    } catch (err) {
      console.log(err);
      if (err)setAddOrgRes(err.response.data);
    }
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      regNumber: values.regNumber ? values.regNumber : orgObj.regNumber,
      organizationName: values.organizationName ? values.organizationName : orgObj.organizationName,
      email: values.email ? values.email : orgObj.email,
      organizationLogo: uploadedImg ? uploadedImg : orgObj.organizationLogo,
      image: uploadedImg1 ? uploadedImg1 : orgObj.image,
      phone: phone ? phone : orgObj.phone,
      contactPerson:values.contactPerson?values.contactPerson:orgObj.contactPerson,
      contactPersonPhone:values.contactPersonPhone?values.contactPersonPhone:orgObj.contactPersonPhone,
      contactPersonEmail:values.contactPersonEmail?values.contactPersonEmail:orgObj.contactPersonEmail,
      organizationType: values.organizationType ? values.organizationType : orgObj.organizationType,
      outletName: values.outletName ? values.outletName : orgObj.outletName,
      address: values.address ? values.address : orgObj.address,
      city: values.city ? values.city : orgObj.city,
      cityId: values.cityId ? values.cityId : orgObj.cityId,
      stateId: values.state ? values.state : orgObj.stateId,
      countryId: values.country ? values.country : orgObj.countryId,
      longitude: values.longitude ? values.longitude : orgObj.longitude,
      latitude: values.latitude ? values.latitude : orgObj.latitude,
      azanTimeMethod:values.azanTimeMethod?values.azanTimeMethod:orgObj.azanTimeMethod,
      fiqa:values.fiqa,
      showAmountBreakup:values.showAmountBreakup?values.showAmountBreakup===true?1:0:null,
      causeAmountPercentage:causeAmountPercentage? Number(causeAmountPercentage.split('%')[0])/100:orgObj.causeAmountPercentage,
      managementFeePercentage:managementFeePercentage?Number(managementFeePercentage.split('%')[0].split('_')[0])/100:orgObj.managementFeePercentage,
      isActive: values.isActive === true ? 1 : 0,
      description: values.description ? values.description : orgObj.description,
      updatedByUserId: user.userId,
    });
    setShow(true);
  };
 
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const submitData=()=>{  
console.log(uploadObj);
if(!phone && orgObj.phone.split("_")[0].length<14){
  console.log("A")
  setShow(false);
  message.error('Invalid mobile number')
  return;
}
else if(phone&&phone.split("_")[0].length<14){
  setShow(false);
  message.error('Invalid mobile number')
  return;
}
else if(!contactPersonPhone && orgObj.contactPersonPhone.split("_")[0].length<14){
  console.log("A")
  setShow(false);
  message.error('Invalid mobile number')
  return;
}
else if(contactPersonPhone&&contactPersonPhone.split("_")[0].length<14){
  setShow(false);
  message.error('Invalid mobile number')
  return;
}
else uploadData(uploadObj);
}
const handleBack=()=>{
  if(user.userType==="A"){navigate('/organizations/listall')}
  else{navigate('/organization/dashboard')}
}
console.log(orgObj);
  return (
    <div class='col-lg-10 mt-4 tbl '>
        <div class="row topbar " style={{height:"70px",width:"873px"}}>
        <div class='col-lg-4 fs-3 fw-bold'>
        {' '}
        <LeftCircleOutlined onClick={handleBack} className='mt-3 ml-4 back-icon' style={{ fontSize: '38px'}} />
      </div>
        <div class='col-lg-7 fs-3 fw-bold '>
        <h2 class=' mb-5 mt-4 fw-bold text-white fs-4'> {t('Update Organization')} </h2>
        </div>
          {' '}
        </div>
      <div class='card'>
        <div class='card-body p-5'>
      
          <div class='col-lg-10 '>
            {res.response ? (
              <Form
                name='basic'
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                style={{
                  maxWidth: 600,
                }}
                initialValues={{
                  remember: true,
                  ['id']: 1,
                  ['regNumber']: orgObj.regNumber,
                  ['organizationName']: orgObj.organizationName,
                  ['outletName']: orgObj.outletName,
                  ['email']: orgObj.email,
                  ['phone']: orgObj.phone,
                  ['contactPerson']:orgObj.contactPerson,
                  ['contactPersonPhone']:orgObj.contactPersonPhone,
                  ['contactPersonEmail']:orgObj.contactPersonEmail,
                  ['organizationName']: orgObj.organizationName,
                  ['organizationType']: orgObj.organizationType,
                  ['address']: orgObj.address,
                  ['city']: orgObj.city,
                  ['state']: orgObj.stateId,
                  ['country']: orgObj.countryId,
                  ['isActive']: orgObj.isActive === 1 ? true : false,
                  ['showAmountBreakup']: orgObj.showAmountBreakup === 1 ? true : false,
                  ['longitude']: orgObj.longitude,
                  ['managementFeePercentage']: orgObj.managementFeePercentage*100,
                  ['causeAmountPercentage']: orgObj.causeAmountPercentage*100,
                  ['latitude']: orgObj.latitude,
                  ['azanTimeMethod']:orgObj.azanTimeMethod,
                  ['fiqa']:orgObj.fiqa,
                  ['description']: orgObj.description,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <Form.Item
                  colon={false}
                  label='Registration / Tax ID'
                  name='regNumber'
                  defaultValue='1'
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Input placeholder="Registration / Tax ID"  />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Organization Name'
                  name='organizationName'
                  rules={[
                    {
                      required: true,
                      message: 'Enter Organization Name',
                    },
                  ]}
                >
                  <Input placeholder="Enter Organization Name" />
                </Form.Item>
                <Form.Item label='Logo'   colon={false}  name='image'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}
              action={`${app.URL}/upload/orglogo`}

              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange}
            >
                {loading?uploadButton:(imageUrl?<img
                    src={imageUrl}
                    alt='avatar'
                    style={{
                      width: '100%',
                    }}
                  />: orgObj&&orgObj.organizationLogo?<img src={orgObj.organizationLogo}/>:" ")}
            </Upload>
          </Form.Item>
          <Form.Item label='Image'   colon={false}  name='image2'>
            <Upload
              // name="avatar"
              listType='picture-card'
              className='avatar-uploader'
              showUploadList={false}
              action={`${app.URL}/upload/orgimage`}
              headers={headers}
              beforeUpload={beforeUpload}
              onChange={handleuploadChange2}
            >
              {loading1?uploadButton:(imageUrl1?<img
                    src={imageUrl1}
                    alt='avatar'
                    style={{
                      width: '100%',
                    }}
                  />: orgObj&&orgObj.image?<img src={orgObj.image}/>:" ")}
            </Upload>
          </Form.Item>
                <Form.Item
                  colon={false}
                  label='Organization Type'
                  name='organizationType'
                  rules={[
                    {
                      required: true,
                      message: 'Select Org type',
                    },
                  ]}
                >
                  <Select
                    style={{
                      width: 280,
                    }}
                    placeholder='Select Organization Type'
                  >
                    {orgTypes.map((type) => {
                      return (
                        <Option key={type.organizationTypeId} value={type.organizationTypeId}>
                          {type.organizationType}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {/* Outlet Name */}
                <Form.Item
                  colon={false}
                  label='Description'
                  name='outletName'
                  rules={[
                    {
                      required: false,
                      message: 'Please input your username!',
                    },
                  ]}
                >
                  <Input placeholder="Enter Description" />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Email'
                  name='email'
                  type='email'
                  rules={[
                    {
                      type: 'email',
                      required: true,
                      message: 'Input Email',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Phone'
                  name='phone'
                  rules={[
                    {
                      required: true,
                      message: 'Please input Phone!',
                    },
                  ]}
                >
                  <InputMask mask='(999) 999-9999' onChange={handleChange}>
                    {(inputProps) => <Input {...inputProps} placeholder='Enter phone number' />}
                    {/* <Input /> */}
                  </InputMask>
                </Form.Item>
                {/* Select box for cause category */}
              

                {/* Select box for organization */}
                <Form.Item
                  colon={false}
                  label='Address'
                  name='address'
                  rules={[
                    {
                      required: true,
                      message: 'Input address',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                {/* City
              <Form.Item
                colon={false}
                label='City'
                name='city'
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}
                  style={{
                    width: 150,
                  }}
                  placeholder='Select'
                >
                  {cities.map((city) => {
                    return (
                      <Option key={city.cityId} value={city.cityId}>
                        {city.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item> */}

         
<Form.Item
                  colon={false}
                  label='Country'
                  name='country'
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                >
                  <Select
                    listHeight={250}
                    listItemHeight={500}
                    disabled={true}
                    style={{
                      width: 280,
                    }}
                    placeholder='Select'
                  >
                    {countries.map((country) => {
                      return (
                        <Option key={country.countryId} value={country.countryId}>
                          {country.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {/* State */}
                <Form.Item
                  colon={false}
                  label='State'
                  name='state'
                  rules={[
                    {
                      required: true,
                      message: 'Select state',
                    },
                  ]}
                >
                  <Select
                    colon={false}
                    listHeight={250}
                    listItemHeight={500}
                    style={{
                      width: 280,
                    }}
                    placeholder='Select State'
                  >
                    {states.map((state) => {
                      return (
                        <Option key={state.stateId} value={state.stateId}>
                          {state.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                       {/* City Input */}
                       <Form.Item
                  colon={false}
                  label='City'
                  name='city'
                  rules={[
                    {
                      required: true,
                      message: 'Enter City',
                    },
                  ]}
                >
                  <Input placeholder='Enter City' style={{ width: 150 }} />
                </Form.Item>
                {/* Country */}
          
           

<Form.Item
                  colon={false}
                  label='Contact Person Name'
                  name='contactPerson'
                  rules={[
                    {
                      required: true,
                      message: 'Enter Contact Person Name',
                    },
                  ]}
                >
                  <Input placeholder="Contact Person Name" />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Contact Person Phone'
                  name='contactPersonPhone'
                  rules={[
                    {
                      required: true,
                      message: 'Please input Phone!',
                    },
                  ]}
                >
                  <InputMask mask='(999) 999-9999' onChange={handleContactPersonChange}>
                    {(inputProps) => <Input {...inputProps} placeholder='Enter phone number' />}
                    {/* <Input /> */}
                  </InputMask>
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Contact Person Email'
                  name='contactPersonEmail'
                  type='email'
                  rules={[
                    {
                      type:'email',
                      required: true,
                      message: 'Enter Contact Person Email',
                    },
                  ]}
                >
                  <Input placeholder="Contact Person Email" />
                </Form.Item>
               <Form.Item label='Show Amount Breakup' colon={false} valuePropName='checked' name='showAmountBreakup'>
                <Switch />
              </Form.Item>
              <Form.Item
                label='Cause Amount Percentage'
                name='causeAmountPercentage'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Input address',
                  },
                ]}
              >
             <InputMask mask='99%' onChange={(e)=>{setcauseAmountPercentage(e.target.value)}}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Cause Amount %'  />}
                  {/* <Input /> */}
                </InputMask>
              </Form.Item>

              <Form.Item
                label='Management Fee Percentage'
                name='managementFeePercentage'
                colon={false}
                rules={[
                  {
                    required: false,
                    message: 'Input address',
                  },
                ]}
              >
               <InputMask mask='99%' onChange={(e)=>{setmanagementFeePercentage (e.target.value)}}>
                  {(inputProps) => <Input {...inputProps} placeholder='Enter Cause Amount %'/>}
                  {/* <Input /> */}
                </InputMask>
              </Form.Item>
              <Form.Item
                colon={false}
                label='Longitude'
                name='longitude'
                rules={[
                  {
                    required: false,
                    message: 'Please input your address!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Latitude'
                name='latitude'
                rules={[
                  {
                    required: false,
                    message: 'Please input your address!',
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                colon={false}
                label='Azan Timing Method'
                name='azanTimeMethod'
                rules={[
                  {
                    required: true,
                    message: 'Please select azan time method',
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}  
                  style={{
                    width: 280,
                  }}
                  placeholder='Select method'
                >
                      <Option key={0} value={0}>
                      Shia Ithna-Ansari
                      </Option>
                      <Option key={1} value={1}>
                      University of Islamic Sciences, Karachi
                      </Option>
                      <Option key={2} value={2}>
                      Islamic Society of North America
                      </Option>
                      <Option key={3} value={3}>
                      Muslim World League
                      </Option>
                      <Option key={4} value={4}>
                      Umm Al-Qura University, Makkah
                      </Option>
                      <Option key={5} value={5}>
                      Egyptian General Authority of Survey
                      </Option>
                      <Option key={7} value={7}>
                      Institute of Geophysics, University of Tehran
                      </Option>
                      <Option key={8} value={8}>
                      Gulf Region
                      </Option>
                      <Option key={9} value={9}>
                      Kuwait
                      </Option>
                      <Option key={10} value={10}>
                      Qatar
                      </Option>
                      <Option key={11} value={11}>
                      Majlis Ugama Islam Singapura, Singapore
                      </Option>
                      <Option key={12} value={12}>
                      Union Organization islamic de France
                      </Option>
                      <Option key={13} value={13}>
                      Diyanet İşleri Başkanlığı, Turkey
                      </Option>
                      <Option key={14} value={14}>
                      Spiritual Administration of Muslims of Russia
                      </Option>
                      <Option key={16} value={16}>
                      Dubai (unofficial)
                      </Option>
                </Select>
              </Form.Item>
              <Form.Item
                colon={false}
                label='Fiqa'
                name='fiqa'
                rules={[
                  {
                    required: true,
                    message: 'Please select fiqa',
                  },
                ]}
              >
                <Select
                  listHeight={250}
                  listItemHeight={500}  
                  style={{
                    width: 280,
                  }}
                  placeholder='Select fiqa'
                >
                      <Option key={0} value={0}>
                      Shafi
                      </Option>
                      <Option key={1} value={1}>
                      Hanafi
                      </Option>
                </Select>
              </Form.Item>
  
                <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                  <Switch />
                </Form.Item>
                {/* <Form.Item
                  colon={false}
                  label='About Organization'
                  name='description'
                  rules={[
                    {
                      message: 'Please input your password!',
                    },
                  ]}
                >
                  <TextArea rows={4} />
                </Form.Item> */}

                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                >
     {addOrgRes.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addOrgRes.message}</Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={()=>{navigate('/organizations/listall')}}>
            Close
          </Button> */}
          {/* <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>:addOrgRes.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addOrgRes.data.message}</Modal.Body>
        <Modal.Footer>
{/*           
          <Button variant="secondary" onClick={()=>{navigate('/organizations/listall');}}>
            Close
          </Button> */}
          {/* <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>  : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to update organization?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>
                Update
                  </button>
                </Form.Item>
              </Form>
            ) : (
              ' '
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrg;
